export default __webpack_public_path__ + "static/media/VD1.ade6ec49.png";